import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { Button, FormControl, Row, Col, Overlay, Popover } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import DuplicateMetadataModal from './DuplicateMetadataModal'

class EditMetadataValue extends Component {
  state = {
    // selectedMetadata: '',
    // selectedMetadataValue: '',
    updatedValue: '',
    showDeletePopover: false,
    newValueAlreadyExists: false,
    valueThatAlreadyExists: null,
    newValueIsExactDuplicate: false,
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedMetadataValue && this.props.selectedMetadataValue !== prevProps.selectedMetadataValue) {
      this.setState({ updatedValue: this.props.selectedMetadataValue.option })
    }
  }

  toggleShowDeletePopover = () => {
    this.setState({ showDeletePopover: !this.state.showDeletePopover})
  }


  handleChange = (event) => this.setState({ [event.target.name]: event.target.value })


  handleCancelSubmit = () => {
    return this.setState({
      newValueAlreadyExists: false,
      valueThatAlreadyExists: null,
      newValueIsExactDuplicate: false,
      updatedValue: this.props.selectedMetadataValue.option || '',
    })
  }


  checkIfMetadataValueExists = () => {

    if (this.state.updatedValue === this.props.selectedMetadataValue.option) {
      return
    }

    if (!this.state.updatedValue) {
      return swal({
        title: "Error",
        text: "Please enter a metadata type before saving",
        icon: "error",
        button: "Continue",
      })
    }

    const { valuesFieldName } = this.props

    const exactMatchingValue = this.props.selectedMetadata[valuesFieldName].find(val => {
      return val.option.toLowerCase() === this.state.updatedValue.toLowerCase()
    })

    if (exactMatchingValue && exactMatchingValue.id !== this.props.selectedMetadataValue.id) {
      return this.setState({
        newValueAlreadyExists: true,
        valueThatAlreadyExists: exactMatchingValue,
        newValueIsExactDuplicate: true,
      })
    }

    const matchingValue = this.props.selectedMetadata[valuesFieldName].find(val => {
      return val.option.toLowerCase().includes(this.state.updatedValue.toLowerCase()) ||
      this.state.updatedValue.toLowerCase().includes(val.option.toLowerCase())
    })

    if (matchingValue && matchingValue.id !== this.props.selectedMetadataValue.id) {
      return this.setState({
        newValueAlreadyExists: true,
        valueThatAlreadyExists: matchingValue,
        newValueIsExactDuplicate: false,
      })
    }

    return this.handleSubmit()
  }



  handleSubmit = () => {
    const { updatedValue } = this.state
    const { selectedMetadataValue } = this.props

    if (updatedValue) {

      swal({
        text: "Saving metadata value... Please stand by.",
        icon: require("../../../static/images/spinner.gif"),
        button: false
      })

      axios({
        method: "PATCH",
        url: `${getServerURL()}${this.props.route}/${selectedMetadataValue.id}/`,
        headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
        data: {
          option: updatedValue,
        }
      })
      .then(response => {
        this.props.editMetadataValue(response.data)
        swal({
          title: "Success",
          text: "The metadata value " + updatedValue + " has been updated",
          icon: "success",
          button: "Continue",
        })
        this.props.resetSelectedMetadataAfterSave()
        this.setState({
          newValueAlreadyExists: false,
          valueThatAlreadyExists: null,
          newValueIsExactDuplicate: false,
        })
      })
      .catch(error => {
        const message = "There was an error editing your metadata value"
        handleErrorFetchingData(error, message)
      })
    } else {
      swal({
        title: "Error",
        text: "Please enter a name for the metadata value before saving",
        icon: "error",
        button: "Continue",
      })
    }
  }


  handleDelete = () => {
    const { selectedMetadataForEdit, selectedMetadataValue } = this.props
    this.toggleShowDeletePopover()

    axios({
      method: "DELETE",
      url: `${getServerURL()}${this.props.route}/${selectedMetadataValue.id}/`,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
    })
    .then(response => {
      this.props.deleteMetadataValue(selectedMetadataValue)
      this.props.resetSelectedMetadataAfterSave()
      swal({
        title: "Success",
        text: `The ${selectedMetadataForEdit.name} ${selectedMetadataValue.option} has been deleted`,
        icon: "success",
        button: "Continue",
      })
    })
    .catch(error => {
      const message = "There was an error deleting your metadata value"
      handleErrorFetchingData(error, message)
    })
  }

  render() {

    const { updatedValue, showDeletePopover, newValueAlreadyExists, valueThatAlreadyExists, newValueIsExactDuplicate } = this.state

    const { selectedMetadataValue, selectedMetadataForEdit, selectedModel, selectedClient } = this.props

    return (
      <div id="EditMetadataType">

        {newValueAlreadyExists ?
          <DuplicateMetadataModal
            show={newValueAlreadyExists}
            name={valueThatAlreadyExists ? valueThatAlreadyExists.option : ""}
            isExactDuplicate={newValueIsExactDuplicate}
            typeOrValue={"value"}
            projectOrProposal={selectedModel}
            client={selectedClient}
            handleSubmit={this.handleSubmit}
            handleCancelSubmit={this.handleCancelSubmit}
          />
          :
          null
        }

        <Row>
          <Col sm={12} md={6}>
            <h5>
              Select a {this.props.selectedModel.toLowerCase()} metadata type
            </h5>
            <FormControl
              componentClass="select"
              name="selectedMetadataForEdit"
              onChange={e => this.props.handleSwitchSelectedMetadata(e, 'selectedMetadataForEdit')}
              selected={selectedMetadataForEdit}
            >
              <option value=''>
                -
              </option>
              {this.props.metadata.map((meta, index) => {
                return (
                  <option
                    key={meta.id}
                    value={meta.id}
                  >
                    {meta.name}
                  </option>
                )
              })}
            </FormControl>
            <br/>
          </Col>
        </Row>
        <Row>
          {selectedMetadataForEdit ?
            <Col sm={12} md={6}>
              <h5>
                Select a {selectedMetadataForEdit.name} value to edit
              </h5>
              <FormControl
                componentClass="select"
                name="selectedMetadata"
                onChange={this.props.handleSelectMetadataValue}
                selected={selectedMetadataValue}
              >
                <option value=''>
                  -
                </option>
                {selectedMetadataForEdit[this.props.valuesFieldName].map(value => {
                  return (
                    <option key={value.id} value={value.id}>
                      {value.option}
                    </option>
                  )
                })}
              </FormControl>
            </Col>
            :
            null
          }
          {selectedMetadataForEdit && selectedMetadataValue ?
            <Col sm={12} md={6}>
              <h5>
                Edit value
              </h5>
              <FormControl
                name="updatedValue"
                value={updatedValue}
                onChange={this.handleChange}
              />
            </Col>
            :
            null
          }
        </Row>
        {selectedMetadataValue ?
          <Row>
            <br/>
            <Col sm={12} md={6}>
              <Button onClick={this.checkIfMetadataValueExists}>
                Save
              </Button>
              <Button
                bsStyle="danger"
                id='deleteMetadataValueButton'
                onClick={this.toggleShowDeletePopover}
                style={{marginLeft: '5px'}}
              >
                Delete
              </Button>
              <Overlay
                show={showDeletePopover}
                onHide={this.toggleShowDeletePopover}
                target={document.getElementById('deleteMetadataValueButton')}
                placement="top"
                rootClose
              >
                <Popover id="deleteMetadataPopover" title="Delete Metadata Value?">
                  Are you sure you want to delete {this.props.selectedMetadataValue.option}?
                  <br/>
                  <br/>
                  <strong>
                    This action cannot be undone.
                  </strong>
                  <br/>
                  <br/>
                  <center>
                    <Button
                      bsStyle="danger"
                      onClick={this.handleDelete}
                      style={{marginRight: '5px'}}
                    >
                      Delete
                    </Button>
                    <Button
                      onClick={this.toggleShowDeletePopover}
                      style={{marginLeft: '5px'}}
                    >
                      Cancel
                    </Button>
                  </center>
                </Popover>
              </Overlay>
            </Col>
          </Row>
          :
          null
        }
      </div>
    )
  }
}

export default EditMetadataValue



// WEBPACK FOOTER //
// ./src/routes/manager/components/EditMetadataValue.js